export default string => string.replace(/([A-Z])/g, c => `_${c.toLowerCase()}`)
